import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana20Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
   <rect width="1221" height="921" fill="url(#pattern0_1467_38256)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("11"))}    
      d="M248.121 674.068L244.53 616.619L309.16 611.233L310.955 622.005C306.646 633.495 306.766 657.91 307.365 668.682L267.869 686.634C256.379 690.943 249.916 680.052 248.121 674.068Z" 
      fill={getFillByLot(11, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("12"))}    
      d="M382.768 564.555C351.171 568.864 321.729 603.453 310.957 620.209L305.571 544.808L364.815 519.674L382.768 564.555Z" 
      fill={getFillByLot(12, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("13"))}    
      d="M463.556 591.486C442.013 561.325 400.722 560.966 382.769 564.557L364.816 519.675L418.674 494.541L463.556 591.486Z" 
      fill={getFillByLot(13, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("14"))}    
      d="M492.276 569.94L465.347 593.279L418.67 494.539L452.78 478.382L492.276 569.94Z" 
      fill={getFillByLot(14, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("15"))}    
      d="M526.388 532.241L492.278 569.941L452.782 478.383L488.688 458.635L526.388 532.241Z" 
      fill={getFillByLot(15, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("16"))}    
      d="M565.877 485.567L526.381 532.243L488.681 458.638L537.153 433.504L565.877 485.567Z" 
      fill={getFillByLot(16, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("17"))}    
      d="M644.88 377.849L565.888 485.564L537.164 433.502L644.88 377.849Z" 
      fill={getFillByLot(17, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("10"))}    
      d="M240.939 566.349L244.53 616.616L309.16 611.23L305.569 544.806L240.939 566.349Z" 
      fill={getFillByLot(10, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("9"))}    
      d="M233.761 496.334L240.942 566.35L300.186 546.602L271.461 478.382L233.761 496.334Z" 
      fill={getFillByLot(9, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("8"))}    
      d="M319.931 456.843L271.459 478.386L300.183 546.606L350.451 525.063L319.931 456.843Z" 
      fill={getFillByLot(8, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("7"))}    
      d="M370.202 433.504L319.935 456.842L350.454 525.062L400.721 501.724L370.202 433.504Z" 
      fill={getFillByLot(7, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("6"))}    
      d="M418.674 411.956L370.202 433.499L400.722 503.515L450.989 478.381L418.674 411.956Z" 
      fill={getFillByLot(6, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("5"))}    
      d="M465.347 388.621L418.67 411.96L450.985 478.384L499.457 453.251L465.347 388.621Z" 
      fill={getFillByLot(5, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("4"))}    
      d="M515.62 361.691L465.353 388.62L499.463 453.25L549.73 426.321L515.62 361.691Z" 
      fill={getFillByLot(4, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("3"))}    
      d="M562.297 338.353L515.621 361.691L549.731 426.32L596.407 402.982L562.297 338.353Z" 
      fill={getFillByLot(3, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("2"))}    
      d="M612.563 313.217L562.295 338.35L596.405 402.98L643.082 377.846L612.563 313.217Z" 
      fill={getFillByLot(2, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M671.801 286.289L612.558 313.218L643.077 379.643L691.549 304.242C692.985 287.007 678.982 285.092 671.801 286.289Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1467_38256" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1467_38256" transform="matrix(0.0024625 0 0 0.00326462 -4.67973 -1.8789)"/>
    </pattern>
    <image id="image0_1467_38256"   width="4096" height="2304" href="/mz2.png"/>
    </defs>
  </svg>
  );
};